import { _configuration } from "./feim/configuration";
import { createMessageListener } from "./feim/createMessageListener";
import { debug } from "./feim/debug";
import { handleIdlePause } from "./modules/handleIdlePause";
import { handleNavigateGame } from "./modules/handleNavigateGame";
import { initializeRcIframe } from "./modules/realityCheckIframe";

export {
    debug
};

export { getConfiguration } from "./feim/configuration";
export { configure } from "./feim/configure";
export * from "./feim/api";
export * from "./feim/types";
export { LogLevel } from "./utils/log";
export { showError} from "./modules/showError";

declare global {
    interface Window {
        rlxfeim: {
            verifyConfiguration: () => boolean;
            log: string[];
        };
    }
}

window.rlxfeim = {
    verifyConfiguration: debug.verifyConfiguration,
    // Only populated if &rlxfeimdebug is present
    log: [],
};

createMessageListener();

// Pause will only trigger in-game once any unfinished round has ended
handleIdlePause();

// Redirect game window on navigate game event
handleNavigateGame();

// Creates the RC iframe if rciframeurl is present
initializeRcIframe();